import { useState } from 'react';
import { useBreakpoint } from '@frontend/responsiveness';
import { useModalControl } from '@frontend/design-system';
import { useInsuranceTabShallowStore } from '../stores';

export const useInlineReport = () => {
  const { shouldReportOpenInLargeModeSwitch } = useInsuranceTabShallowStore('shouldReportOpenInLargeModeSwitch');
  const { modalProps, triggerProps } = useModalControl();
  const [isReportOpen, setIsReportOpen] = useState(false || shouldReportOpenInLargeModeSwitch);
  const size = useBreakpoint();
  const isMobile = size === 'xsmall' || size === 'small' || size === 'medium' || size === 'mobile';
  return {
    switchToLargeModalProps: modalProps,
    switchToLargeModalTriggerProps: isMobile ? triggerProps : {},
    isReportOpen,
    setIsReportOpen,
  };
};
